// Résout l'objet d'un e-mail au moment où un message prédéfini est appliqué.
//
// L'objet personnalisé du message prédéfini l'emporte toujours : depuis un
// dossier, l'objet est pré-rempli par le back (nom du défunt), ce qui empêchait
// jusqu'ici le remplacement et rendait le comportement différent de celui de la
// Messagerie. Quand le message prédéfini n'a pas d'objet personnalisé, l'objet
// déjà présent est conservé.
export const resolveTemplateSubject = (currentSubject, templateSubject) => {
  const template = templateSubject ?? ''

  if (template.trim().length) {
    return template
  }

  return currentSubject ?? ''
}

// Détermine s'il faut demander confirmation avant d'écraser l'objet.
//
// On ne dérange l'utilisateur que s'il a lui-même touché à l'objet : `initialSubject`
// est l'objet tel que le back l'a renvoyé à l'ouverture de la modale (nom du défunt
// depuis un dossier, vide depuis la Messagerie). Tant que l'objet courant est resté
// identique à celui-là, l'écrasement est silencieux ; dès qu'il en diffère, c'est une
// saisie manuelle et on demande.
export const shouldConfirmSubjectOverride = (
  initialSubject,
  currentSubject,
  templateSubject
) => {
  const template = (templateSubject ?? '').trim()

  if (!template.length) {
    return false
  }

  const current = (currentSubject ?? '').trim()

  if (!current.length || current === template) {
    return false
  }

  return current !== (initialSubject ?? '').trim()
}
